var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessstart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_57702)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.083252,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2469F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2891 31.2009C32.6688 30.7938 32.8711 30.2525 32.8517 29.6962C32.8323 29.1398 32.5926 28.614 32.1855 28.2344L30.1387 26.3257C29.7316 25.9461 29.1903 25.7437 28.634 25.7631C28.0776 25.7825 27.5518 26.0222 27.1722 26.4293L26.695 26.941L22.7652 23.2764C22.7923 23.1569 22.8037 23.0343 22.799 22.9119L22.6752 19.3658C22.6621 18.995 22.5024 18.6445 22.231 18.3915C21.9597 18.1384 21.5989 18.0035 21.2281 18.0164L17.682 18.1402C17.3112 18.1532 16.9608 18.313 16.7077 18.5843C16.4546 18.8557 16.3197 19.2165 16.3326 19.5873L16.4565 23.1333C16.4608 23.2579 16.4819 23.379 16.5156 23.4946L12.851 27.4244L12.3393 26.9473C11.9322 26.5676 11.3909 26.3652 10.8346 26.3847C10.2782 26.4041 9.75238 26.6437 9.37273 27.0509L7.46408 29.0976C7.08443 29.5048 6.88205 30.046 6.90148 30.6024C6.92091 31.1587 7.16055 31.6846 7.56767 32.0642L9.61445 33.9729C10.0216 34.3525 10.5629 34.5549 11.1192 34.5355C11.6755 34.516 12.2014 34.2764 12.581 33.8693L14.4897 31.8225C14.8693 31.4154 15.0717 30.8741 15.0523 30.3178C15.0328 29.7614 14.7932 29.2356 14.3861 28.8559L13.8744 28.3788L17.539 24.449C17.6585 24.4761 17.7811 24.4875 17.9035 24.4828L21.4496 24.3589C21.5721 24.3551 21.6935 24.3352 21.8109 24.2998L25.7407 27.9644L25.2635 28.4761C24.8839 28.8832 24.6815 29.4245 24.7009 29.9808C24.7203 30.5372 24.96 31.063 25.3671 31.4427L27.4139 33.3513C27.821 33.731 28.3623 33.9333 28.9186 33.9139C29.475 33.8945 30.0008 33.6548 30.3804 33.2477L32.2891 31.2009ZM31.2312 29.2577C31.3669 29.3843 31.4468 29.5596 31.4532 29.745C31.4597 29.9305 31.3923 30.1109 31.2657 30.2466L29.3571 32.2934C29.2305 32.4291 29.0552 32.509 28.8698 32.5154C28.6843 32.5219 28.5039 32.4545 28.3682 32.3279L26.3214 30.4193C26.1857 30.2927 26.1058 30.1174 26.0994 29.932C26.0929 29.7465 26.1603 29.5661 26.2869 29.4304L28.1955 27.3836C28.3221 27.2479 28.4974 27.168 28.6828 27.1616C28.8683 27.1551 29.0487 27.2225 29.1844 27.3491L31.2312 29.2577ZM21.2769 19.4146L21.4007 22.9607L17.8547 23.0845L17.7309 19.5385L21.2769 19.4146ZM13.4663 30.8682L11.5576 32.9149C11.4311 33.0507 11.2558 33.1305 11.0704 33.137C10.8849 33.1435 10.7045 33.076 10.5688 32.9495L8.522 31.0408C8.38629 30.9143 8.30641 30.739 8.29994 30.5536C8.29346 30.3681 8.36092 30.1877 8.48747 30.052L10.3961 28.0052C10.5227 27.8695 10.698 27.7896 10.8834 27.7831C11.0688 27.7767 11.2493 27.8441 11.385 27.9707L13.4318 29.8793C13.5675 30.0059 13.6473 30.1811 13.6538 30.3666C13.6603 30.552 13.5928 30.7325 13.4663 30.8682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.75,
    y: 6.47607,
    width: 5.5,
    height: 5.5,
    rx: 1.25,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 12.7261,
    x2: 19.5,
    y2: 18.7261,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_57702"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.083252,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessstart);
export default __webpack_public_path__ + "static/media/processstart.58c751bf30669152908372e419a61e04.svg";
export { ForwardRef as ReactComponent };